import { Heading } from "@elaniintc/goes-design-system";
import { PaymentRow } from "./PaymentRow";
import type { PaymentRequest } from "@/queries/payment";
import {
  formatCurrency,
  getApplicantName,
  getPaymentDateValue,
  getPaymentMethodValue,
  getReferenceCode,
  getStatusColorClass,
  getTotalColorClass,
  getTotalLabel,
} from "./PaymentSummary.utils";

interface PaymentSummaryProps {
  paymentData: PaymentRequest;
}

export const PaymentSummary = ({ paymentData }: PaymentSummaryProps) => {
  return (
    <div className="bg-neutral-object border border-neutral-quiet rounded-xl">
      <Heading variant="h6" className="border-b border-neutral-quiet p-3">
        Resumen de pago
      </Heading>
      <div className="px-3">
        <PaymentRow
          label="Referencia"
          value={getReferenceCode(paymentData.payments || [])}
          valueColor="loud"
          useMonoFont
        />
        <PaymentRow
          label="Fecha de pago"
          value={getPaymentDateValue({
            status: paymentData.status,
            updated_at: paymentData.updated_at,
          })}
          valueColor={getStatusColorClass(paymentData.status)}
        />
        <PaymentRow
          label="Método de pago"
          value={getPaymentMethodValue(
            paymentData.payments || [],
            paymentData.status,
          )}
          valueColor={getStatusColorClass(paymentData.status)}
        />
        <PaymentRow
          label="Pagador"
          value={
            paymentData.status === "EXEMPT"
              ? "Eximido"
              : getApplicantName(paymentData.applicant || null)
          }
          valueColor={getStatusColorClass(paymentData.status)}
        />
        <PaymentRow
          label={getTotalLabel(paymentData.status)}
          value={formatCurrency(paymentData.amount)}
          valueColor={getTotalColorClass(paymentData.status)}
          isTotal
        />
      </div>
    </div>
  );
};
